export default {
    cancel: 'Cancel',
    changePassword: 'Change password',
    rotatePassword: 'By security policies the password must be changed',
    confirmNewPasswordLabel: 'Confirm new password',
    newPassword: 'New password',
    newPasswordLabel: 'Enter new password',
    currentPassword: 'Current password',
    passwordMinLength: 'At least {n} characters',
    passwordLowerCase: 'At least 1 lower case',
    passwordUpperCase: 'At least 1 upper case',
    specialCharacter: 'At least 1 special character {n}',
    number: 'At least 1 number',
    updateSuccess: 'The password has been updated'
  }
  